"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const Input = styled_components_1.default.input `
  opacity: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  position: relative;
  z-index: 1;
  cursor: ${({ disabled }) => (disabled ? "auto" : "pointer")};
`;
const StyledSwtichContainer = styled_components_1.default.span `
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
`;
const StyledLabel = styled_components_1.default.div `
  position: relative;
  display: flex;
  pointer-events: none;
  margin-left: 20px;
  font-size: 16px;
  font-weight: 400;
  color: ${({ disabled, theme }) => disabled ? theme.text.secondary : theme.text.primary};
`;
const Wrapper = styled_components_1.default.span `
  width: 51px;
  height: 31px;
  position: relative;
  display: inline-block;
  border-radius: 24px;
  background-color: ${({ checked, disabled, theme }) => disabled
    ? checked
        ? theme.neutral.main
        : theme.neutral.light
    : checked
        ? theme.primary.main
        : theme.neutral.lighter};
  transition: 200ms;
  overflow: hidden;
`;
const Circle = styled_components_1.default.div `
  width: 27px;
  height: 27px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.white};
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  color: ${({ theme }) => theme.primary.main};
  ${({ checked }) => (checked ? "left: 22px;" : "left: 2px;")}
  transition: left 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,transform 150ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  box-shadow: 0px 3px 8px rgba(0, 0, 0, 0.15), 0px 3px 1px rgba(0, 0, 0, 0.06);
`;
const Switch = (0, react_1.forwardRef)((_a, ref) => {
    var { label = null, checked = false, disabled = false, iconOn, iconOff } = _a, props = __rest(_a, ["label", "checked", "disabled", "iconOn", "iconOff"]);
    return (react_1.default.createElement(StyledSwtichContainer, null,
        react_1.default.createElement(Wrapper, { checked: checked, disabled: disabled },
            react_1.default.createElement(Input, Object.assign({ type: "checkbox", ref: ref, checked: checked, disabled: disabled }, props)),
            iconOn && iconOff ? (react_1.default.createElement(Circle, { checked: checked }, checked ? iconOn : iconOff)) : (react_1.default.createElement(Circle, { checked: checked }))),
        label && react_1.default.createElement(StyledLabel, { disabled: disabled }, label)));
});
exports.default = Switch;
